<script setup lang="ts">
import type { CreditStep } from '~/composables/credit';
import type { Component } from 'vue';

import {
	useCreditSimulator,
	useCreditSimulatorAnchor
} from '~/composables/credit';

import CreditSimulatorContactStep from './CreditSimulatorContactStep.vue';
import CreditSimulatorProductStep from './CreditSimulatorProductStep.vue';
import CreditSimulatorProfileStep from './CreditSimulatorProfileStep.vue';
import CreditSimulatorSuccessStep from './CreditSimulatorSuccessStep.vue';

const STEPS: Record<CreditStep, Component> = {
	0: CreditSimulatorProductStep,
	1: CreditSimulatorProfileStep,
	2: CreditSimulatorContactStep,
	3: CreditSimulatorSuccessStep
};

// Reuses the labels already on screen, read aloud when the step changes.
const STEP_ANNOUNCEMENTS: Record<CreditStep, string> = {
	0: 'Simule em 1 minuto',
	1: 'Passo 2 de 3',
	2: 'Passo 3 de 3',
	3: 'Recebemos sua simulação.'
};

const { state } = useCreditSimulator();
// Template ref, so the links that lead here can scroll to the card.
const { card } = useCreditSimulatorAnchor();
const currentStep = ref<{ focusHeading: () => void } | null>(null);
const announcement = ref('');

// Only after a user action: focusing on load would steal the scroll.
watch(
	() => state.value.step,
	async step => {
		announcement.value = STEP_ANNOUNCEMENTS[step];
		await nextTick();
		currentStep.value?.focusHeading();
	}
);
</script>

<template>
	<div
		ref="card"
		class="max-w-[540px] min-w-0 flex-[1_1_420px] scroll-mt-[76px] rounded-xs lg:scroll-mt-24 border border-[#262626] bg-[#141414] p-7 text-[#FAFAFA]"
	>
		<div aria-live="polite" class="sr-only">{{ announcement }}</div>
		<component :is="STEPS[state.step]" ref="currentStep" />
	</div>
</template>
